import type { Settings } from '@muddle/core';

export type ThemePref = Settings['theme'];

// The server is the source of truth for the theme (it follows your data). This key only caches the
// last value so the first paint doesn't flash the wrong scheme; every read/write is guarded.
const HINT_KEY = 'muddle_theme_hint';

/** 'system' removes the override so the OS setting decides (the default). */
export function applyTheme(theme: ThemePref): void {
  const root = document.documentElement;
  if (theme === 'light' || theme === 'dark') root.setAttribute('data-theme', theme);
  else root.removeAttribute('data-theme');
  try {
    localStorage.setItem(HINT_KEY, theme);
  } catch {
    /* private mode or blocked storage: the server value still applies after load */
  }
}
